// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__7ldBJ","spin":"Loader_spin__x-ycw","container":"Loader_container__fqccx"};